<template>
  <div class="unidades-contenedor">
    <h2 class="mb-4">Unidades de Medida</h2>

    <div class="alerta-info mb-3">
      Catálogo global de unidades. Esta pantalla es solo lectura.
    </div>

    <div class="tarjeta">
      <div class="tarjeta-cuerpo">
        <div v-if="cargando" class="text-center py-5">
          <div class="spinner-border" role="status" style="color: var(--primary-main);">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </div>

        <div v-else-if="unidades.length === 0" class="alerta-info">
          No se encontraron unidades de medida registradas.
        </div>

        <div v-else class="table-responsive">
          <table class="tabla-datos">
            <thead>
              <tr>
                <th>Código</th>
                <th>Unidad</th>
                <th>Abreviatura</th>
                <th>Tipo</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="unidad in unidades" :key="unidad.id">
                <td><code class="codigo-texto">{{ unidad.codigo }}</code></td>
                <td>{{ unidad.unidad_medida }}</td>
                <td><span class="insignia-codigo">{{ unidad.abreviatura }}</span></td>
                <td>
                  <span class="insignia" :class="obtenerClaseTipo(unidad.tipo)">
                    {{ obtenerEtiquetaTipo(unidad.tipo) }}
                  </span>
                </td>
                <td>
                  <span class="insignia" :class="unidad.activo ? 'insignia-exito' : 'insignia-secundaria'">
                    {{ unidad.activo ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inventarioService } from '@/services/inventarioService';

export default {
  name: 'ClientInventarioUnidadesMedida',
  data() {
    return {
      unidades: [],
      cargando: false,
    };
  },
  mounted() {
    this.cargarUnidades();
  },
  methods: {
    async cargarUnidades() {
      this.cargando = true;
      try {
        const respuesta = await inventarioService.getUnidadesMedida();
        this.unidades = respuesta?.data || [];
      } catch (error) {
        console.error('Error al cargar unidades de medida:', error);
        this.unidades = [];
      } finally {
        this.cargando = false;
      }
    },
    obtenerEtiquetaTipo(tipo) {
      const etiquetas = {
        cantidad: 'Cantidad',
        peso: 'Peso',
        volumen: 'Volumen',
        longitud: 'Longitud',
        area: 'Area',
        tiempo: 'Tiempo',
        servicio: 'Servicio',
        paquete: 'Paquete'
      };
      return etiquetas[tipo] || tipo;
    },
    obtenerClaseTipo(tipo) {
      const clases = {
        cantidad: 'insignia-primaria',
        peso: 'insignia-advertencia',
        volumen: 'insignia-info',
        longitud: 'insignia-secundaria',
        area: 'insignia-exito',
        tiempo: 'insignia-peligro',
        servicio: 'insignia-oscura',
        paquete: 'insignia-paquete'
      };
      return clases[tipo] || 'insignia-secundaria';
    }
  }
};
</script>

<style scoped>
.unidades-contenedor {
  padding: 20px;
  color: var(--text-primary);
}
.tarjeta {
  background-color: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 8px;
  box-shadow: var(--shadow-sm);
}
.tarjeta-cuerpo { padding: 1rem; }
.tabla-datos { width: 100%; border-collapse: collapse; }
.tabla-datos th {
  background-color: var(--bg-main);
  color: var(--text-secondary);
  font-weight: 600;
  padding: 0.75rem;
  border-bottom: 1px solid var(--border-main);
  text-align: left;
}
.tabla-datos td {
  padding: 0.75rem;
  border-bottom: 1px solid var(--border-main);
  color: var(--text-primary);
}
.tabla-datos tr:hover td { background-color: var(--bg-main); }
.alerta-info {
  padding: 1rem;
  background-color: var(--bg-main);
  border: 1px solid var(--border-main);
  border-radius: 6px;
  color: var(--text-secondary);
}
.insignia {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}
.insignia-primaria { background-color: var(--primary-main); color: white; }
.insignia-exito { background-color: var(--accent-success); color: white; }
.insignia-advertencia { background-color: var(--accent-warning); color: var(--text-primary); }
.insignia-peligro { background-color: var(--accent-danger); color: white; }
.insignia-secundaria { background-color: var(--text-muted); color: white; }
.insignia-info { background-color: var(--primary-hover); color: white; }
.insignia-oscura { background-color: var(--text-secondary); color: white; }
.insignia-paquete { background-color: #0f766e; color: white; }
.insignia-codigo {
  background-color: var(--bg-main);
  border: 1px solid var(--border-main);
  color: var(--text-secondary);
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  font-size: 0.85rem;
}
.codigo-texto { color: var(--primary-main); font-size: 0.9rem; }
</style>
